import React from 'react'
import { Tooltip, Typography, Button, Timeline, Popover, Empty } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { TableIdEnum } from '@configs/table'
import { useCallRecordDetail } from '../useCallRecordDetail'
import '../style.less'

interface PropsType {
  disabled: boolean
  playTips: string
  recordId: string | number
}

const T3CTimeLineBtn: React.FC<React.PropsWithChildren<PropsType>> = (props) => {
  const { disabled, playTips, recordId } = props
  const { callRecordDetail, getCallRecordDetail, open, setOpen, loading } = useCallRecordDetail(TableIdEnum.TCCC_CALL_RECORD)

  return (
    <>
      {disabled ? (
        <Tooltip title={playTips}>
          <Button
            disabled={disabled}
            style={{ padding: 0 }}
            type="link"
          >
            时间线
          </Button>
        </Tooltip>
      ) : (
        <Popover
          open={open}
          onOpenChange={() => setOpen(false)}
          overlayClassName="call-record-time-line-pop"
          content={
            <>
              {callRecordDetail?.callEventList?.length ? (
                <Timeline mode="left">
                  {callRecordDetail?.callEventList?.map((item, index) => (
                    <Timeline.Item key={index} label={item.standardTime}>
                      <Typography.Text ellipsis={{ tooltip: item.eventText }}>
                        {item.eventText}
                      </Typography.Text>
                    </Timeline.Item>
                  ))}
                </Timeline>
              ) : (<Empty />)}
            </>
          }
          title={null}
          trigger="click"
          arrowPointAtCenter
        >
          {loading ? (
            <LoadingOutlined style={{ cursor: 'pointer', color: '#1890ff' }} />
          ) : (
            <Button
              type="link"
              disabled={disabled}
              style={{ padding: 0 }}
              onClick={() => getCallRecordDetail(recordId)}
            >
              时间线
            </Button>)}
        </Popover>
      )}
    </>
  )
}

export default T3CTimeLineBtn
